import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
import { Player } from '../../jscaip/Player';
import { PlayerNumberMap } from '../../jscaip/PlayerMap';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
export class AbstractGoHeuristic extends PlayerMetricHeuristic {
    rules;
    constructor(rules) {
        super();
        this.rules = rules;
    }
    getMetrics(node) {
        const goState = this.rules.markTerritoryAndCount(node.gameState);
        const goScore = goState.captured;
        const goKilled = this.getDeadStones(goState);
        return PlayerNumberTable.ofSingle(goScore.get(Player.ZERO) + (2 * goKilled.get(Player.ONE)), goScore.get(Player.ONE) + (2 * goKilled.get(Player.ZERO)));
    }
    getDeadStones(state) {
        const killed = PlayerNumberMap.of(0, 0);
        for (const coordAndContent of state.getCoordsAndContents()) {
            const piece = coordAndContent.content;
            if (piece.type === 'dead') {
                killed.add(piece.player, 1);
            }
        }
        return killed;
    }
}
